import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import moment from 'moment';
import React, { Fragment, useState } from 'react';
import { IConfirmation } from '../schemas';
import {QueryDocumentSnapshot, QuerySnapshot} from 'firebase/firestore';
import BookingCard from './BookingCard';

export interface IBookingsList {
  bookings: QuerySnapshot<IConfirmation>;
}

export default function BookingsList(props: IBookingsList) {
  const {bookings} = props;
  const [booking, setBooking] = useState<QueryDocumentSnapshot<IConfirmation> | null>(null);
  return (
    <Fragment>
      <List dense disablePadding>
        {bookings.docs
          .map((doc: QueryDocumentSnapshot<IConfirmation>) => {
            const confirmation = doc.data() as IConfirmation;
            const timestamp = moment(confirmation.created).format('MMM Do YYYY, h:mm a');
            let status = 'Waiting confirmation';
            if (typeof confirmation.approved === 'boolean') {
              if (confirmation.approved) {
                status = 'User Confirmed';
              } else {
                status = 'User Rejected';
              }
            }
            return (
              <ListItem
                key={doc.id}
                dense
                button
                onClick={() => {
                  setBooking(doc)
                }}
              >
                <ListItemText
                  id={doc.id}
                  primary={`${confirmation.userName}, ${confirmation.dogName} appointment ${confirmation.organizationId}`}
                  // primaryTypographyProps={{ style: { 'textDecoration': option.active ? 'none' : 'line-through' } }}
                  secondary={`Created ${timestamp} - ${status}`}
                  secondaryTypographyProps={{ style: { fontSize: 10 } }}
                />
                <ListItemSecondaryAction>
                  {confirmation.approved && <CheckCircleIcon/>}
                </ListItemSecondaryAction>
              </ListItem>)}
          )}
      </List>
      <Dialog open={!!booking} onClose={() => setBooking(null)}>
        <Grid container direction="column" alignItems="center">
          {booking && <BookingCard data={booking.data() as IConfirmation}/>}
        </Grid>
      </Dialog>
    </Fragment>
  )
}
